export default __webpack_public_path__ + "static/media/back-arrow.775002cb.svg";